import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { set_phone_input_values, edit_my_phone_saga, check_my_phone_saga, set_phone } from "../../../store/actions/my-info";
import { useRouter } from "next/router";
const changePhoneHook = (props) => {
    const dispatch = useDispatch();
    const router = useRouter();
    const my_info = useSelector(state => state.edit);
    const change_phone = useSelector(state => state.change_phone);
    const [showCode, setShowCode] = useState(false);
    const handleClick = (href) => {
        router.push(href)
    }
    const keyPress = (e) => {
        if (e.key === "Enter") {
            edit_phone_saga()
        }
    }
    const set_input_value = (e) => {
        dispatch(set_phone_input_values(e))
    }
    const edit_phone_saga = () => {
        dispatch(edit_my_phone_saga({ data: change_phone.data, token: props.token, cb: () => setShowCode(true) }))
    }
    const check_phone_saga = () => {
        dispatch(check_my_phone_saga({ data: change_phone.data, token: props.token, cb: () => { props.setValue(); setShowCode(false) } }))
    }
    const set_phone_value = () => {
        dispatch(set_phone({ phone_number: { value: my_info.data.phone_number, valid: true } }))
    }
    useEffect(() => {
        set_phone_value()
    }, []);
    return {
        showCode,
        setShowCode,
        keyPress,
        change_phone,
        set_input_value,
        edit_phone_saga,
        check_phone_saga
    }
}
export default changePhoneHook;